var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / ic_notes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M7.3479 9.22241C4.3288 9.22241 1.75 9.69841 1.75 11.6024C1.75 13.5071 4.3127 13.9999 7.3479 13.9999C10.367 13.9999 12.9458 13.5246 12.9458 11.6199C12.9458 9.71521 10.3838 9.22241 7.3479 9.22241Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    d: "M7.34795 7.4088C9.40455 7.4088 11.0524 5.7603 11.0524 3.7044C11.0524 1.6485 9.40455 0 7.34795 0C5.29205 0 3.64355 1.6485 3.64355 3.7044C3.64355 5.7603 5.29205 7.4088 7.34795 7.4088Z",
    fill: "#484848",
    fillOpacity: 0.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotes);
export default __webpack_public_path__ + "static/media/ic_notes.6da203f123f6d0ef5b514f50399c7860.svg";
export { ForwardRef as ReactComponent };